import { User } from "@app/user/model/user";
import { ClareUserPermission, ROLE_NAMES } from "@app/user/model/user-role";

export interface AuthUser extends User {
    uid: string;
    displayName: string;
    entityName?: string;
}

export interface SsoUserInfo {
    account_number: string | null;
    create_time: string;
    email: string;
    entity: {
        name: string;
    };
    entity_id: number;
    first_name: string;
    git_id: string;
    id: number;
    invite_code: string;
    last_name: string;
    notes: string | null;
    phone: string | null;
    phone_2: string | null;
    phone_2_type: string | null;
    phone_3: string | null;
    phone_3_type: string | null;
    phone_type: string | null;
    role: {
        permissions: Array<{ name: string }>;
    };
    role_id: number;
    role_name: {
        name: ROLE_NAMES;
    };
}

/* eslint-disable @typescript-eslint/naming-convention */
export type FirebaseUserWithPermissions = {
    Email: string;
    UID: string;
    DisplayName: string;
} & { ssoUserInfo: SsoUserInfo; ssoUserPermissions: ClareUserPermission[]; entityName?: string };
/* eslint-enable @typescript-eslint/naming-convention */

export class AuthUserHelper {
    /* eslint-disable-next-line @typescript-eslint/naming-convention */
    static fromDbObject({ Email, UID, DisplayName, ssoUserInfo, ssoUserPermissions, entityName }: FirebaseUserWithPermissions): AuthUser {
        return {
            email: Email,
            uid: UID,
            displayName: DisplayName,
            entityId: ssoUserInfo.entity_id,
            firstName: ssoUserInfo.first_name,
            lastName: ssoUserInfo.last_name,
            phone: ssoUserInfo.phone,
            id: ssoUserInfo.id,
            roleId: ssoUserInfo.role_id,
            role: {
                id: ssoUserInfo.role_id,
                name: ssoUserInfo?.role_name?.name,
                permissions: ssoUserPermissions,
            },
            permissions: ssoUserPermissions?.map(p => p.name),
            entityName,
        };
    }
}
export interface AuthenticationReqs {
    email: string;
    password: string;
    displayName?: string;
    inviteCode?: string;
}

export interface ResetPasswordRequestParams {
    oobCode: string;
    mode: string;
    lang?: string;
    newPassword?: string;
    continueUrl?: string;
}

export interface ValidateInviteCodeRequestParams {
    inviteCode: string;
    isStaff: boolean;
}
